import { required } from 'vuelidate/lib/validators'
import Fileupload from '@/components/common/fileupload/Fileupload.vue'

const defaultEl = {
  id: null,
  title: {},
  content: {},
  date: '',
  files: []
};

export default {
  name: 'InfoEditItem',
  props: ['itemname'],
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  components: {
    Fileupload
  },
  validations: {
    editEl: {
      date: { required }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.' + this.itemname + '.edit');
      }
      return this.$t('menu.' + this.itemname + '.new');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        const tmpEl = this.BasicHelper.cloneObject(elData);
        tmpEl.title = (tmpEl.title === null) ? {} : tmpEl.title;
        tmpEl.content = (tmpEl.content === null) ? {} : tmpEl.content;
        tmpEl.files = (tmpEl.files === null) ? [] : tmpEl.files;
        this.editEl = tmpEl;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$forceUpdate();
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = this.ApiRequest.createFormData(this.editEl, ['id', 'title', 'content', 'date'], 'info', this);
        if (reqData) {
          const self = this;
          this.ApiRequest.request('info/' + this.itemname + '/edit', this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
            if (response.error) {
              self.ApiRequest.displayErrorDialog(response, self);
            } else {
              self.$emit('saved', response.data);
              self.close();
            }
            self.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    downloadfile (key) {
      this.editEl.files[key].loading = true;
      this.$refs.fileupload.forceUpdate(key);
      const self = this;
      this.ApiRequest.request('info/' + this.$route.meta.reqpath + '/downloadfile/' + this.editEl.files[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.editEl.files[key].loading = false;
        self.$refs.fileupload.forceUpdate(key);
      });
    }
  }
}
